import { makeStyles } from '@material-ui/core'
export const useStyles = makeStyles(() => ({
    option: {
        padding: '12px 16px',
        border: '1px solid rgba(0, 0, 0, .125)',
        width: '40%',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        lineHeight: 'normal',
        cursor: 'pointer',
        '@media (max-width: 767px)': {
            width: '100%',
        },
    },
    contact: {
        padding: '16px 1px',
        marginBottom: '40px',
    },
    playIcon: {
        fontSize: '10px',
        margin: 'auto 0',
    },
}))
